const
    delayed = (fn, delay) => {
        let timeout = (
                setTimeout(
                    () => {
                        timeout = null;
                        fn();
                    },
                    delay));

        return () => {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
                fn = null;
            }
        };
    },

    repeated = (fn, delay) => {
        let interval = (
                setInterval(
                    () => {
                        fn();
                    },
                    delay));

        return () => {
            if (interval) {
                clearInterval(interval);
                interval = null;
                fn = null;
            }
        };
    },

    animated = fn => {
        let request = (
                requestAnimationFrame(
                    () => {
                        fn();
                    }));

        return () => {
            if (request) {
                cancelAnimationFrame(request);
                request = null;
                fn = null;
            }
        };
    };

export {
    delayed,
    repeated,
    animated
};
